
<a v-if="showLink && href" :href="href" class="btn-link" v-bind="customBindings">
  <slot></slot>
</a>
<component :is="tag" v-else>
  <slot></slot>
</component>
